"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var createSvgIcon_1 = __importDefault(require("../createSvgIcon"));
var Rotate = (0, createSvgIcon_1.default)(React.createElement("path", { d: "M9.76228 4.34575L5.91653 0.5V3.09482C2.58637 3.50898 0 6.34892 0 9.79741C0 13.2459 2.57792 16.0858 5.91653 16.5V14.7927C3.51611 14.387 1.69044 12.3077 1.69044 9.79741C1.69044 7.28711 3.51611 5.20787 5.91653 4.80217V8.10697L9.76228 4.34575ZM13.4643 8.95219C13.3207 7.77734 12.8558 6.64474 12.0951 5.66429L10.8949 6.8645C11.3513 7.49841 11.6387 8.21685 11.757 8.95219H13.4643ZM7.60697 14.7842V16.4915C8.78183 16.3479 9.92287 15.8914 10.9033 15.1307L9.68621 13.9136C9.0523 14.37 8.34231 14.6659 7.60697 14.7842ZM10.8949 12.7388L12.0951 13.9305C12.8558 12.9501 13.3207 11.8175 13.4643 10.6426H11.757C11.6387 11.378 11.3513 12.0964 10.8949 12.7388Z" }), 'Rotate');
exports.default = Rotate;
//# sourceMappingURL=index.js.map